import { RouteInfo } from "./sidebar.metadata";

// Full route config
const ORIGINAL_EMPLOYEE_ROUTES: any = [
  {
    path: "/user/employee-dashboard",
    title: "Dashboard",
    icon: "mdi mdi-view-dashboard",
    module: "employee-dashboard",
    class: "",
    hasSubmenu: false,
    extralink: false,
    submenu: [],
  },
  {
    // path: "user/users-booking",
    title: "Users/Customers",
    icon: "mdi mdi-account",
    class: "has-arrow",
    hasSubmenu: true,
    extralink: false,
    submenu: [
      {
        path: "/user/users-booking",
        title: "User Bookings",
        module: "users-booking",
        icon: "fa fa-user-plus",
        class: "",
        extralink: false,
        submenu: [],
      },
      {
        path: "user/users-advance-booking",
        title: "User Advance Bookings",
        module: "users-advance-booking",
        icon: "fa fa-user-plus",
        class: "",
        extralink: false,
        submenu: [],
      },
      {
        path: "/user/transactions",
        title: "Transactions",
        module: "transactions",
        icon: "mdi mdi-wallet",
        class: "",
        extralink: false,
        submenu: [],
      },
      {
        path: "/user/news-letter",
        title: "Newsletter",
        module: "news-letter",
        icon: "mdi mdi-playlist-check",
        class: "",
        extralink: false,
        submenu: [],
      },
      {
        path: "/user/customer-review",
        title: "Customer Review",
        module: "customer-review",
        icon: "mdi mdi-star",
        class: "",
        extralink: false,
        submenu: [],
      },
    ],
  },
  {
    path: "/user/my-assigned-advance-booking",
    title: "My assigned advance booking",
    icon: "mdi mdi-calendar",
    module: "my-assigned-advance-booking",
    class: "",
    hasSubmenu: false,
    ForEmployee: true,
    extralink: false,
    submenu: [],
  },
  {
    // path: "/user/vending-product",
    title: "Vending",
    icon: "mdi mdi-domain",
    class: "has-arrow",
    hasSubmenu: true,
    extralink: false,
    submenu: [
      {
        path: "/user/vending-product",
        title: "Product Info",
        icon: "mdi mdi-domain",
        module: "vending-product",
        class: "",
        extralink: false,
        submenu: [],
      },
      {
        path: "/user/vending-store",
        title: "Store Info",
        icon: "mdi mdi-domain",
        module: "vending-store",
        class: "",
        extralink: false,
        submenu: [],
      },
      {
        path: "/user/festivals",
        title: "Festivals",
        icon: "mdi mdi-domain",
        module: "festivals",
        class: "",
        extralink: false,
        submenu: [],
      },
      {
        path: "/user/vending-orders",
        title: "Order Management",
        icon: "mdi mdi-domain",
        module: "vending-orders",
        class: "",
        extralink: false,
        submenu: [],
      },
    ],
  },

  {
    // path: "/user/rent-package",
    title: "Packages",
    icon: "mdi mdi-package",
    class: "has-arrow",
    hasSubmenu: true,
    extralink: false,
    submenu: [
      {
        path: "/user/rent-package",
        title: "Rent Package",
        icon: "mdi mdi-package-up",
        module: "rent-package",
        class: "",
        extralink: false,
        submenu: [],
      },
      {
        path: "/user/book_package",
        title: "Book Package",
        icon: "mdi mdi-package-up",
        module: "book_package",
        class: "",
        extralink: false,
        submenu: [],
      },

      {
        path: "/user/sale-package",
        title: "Sale Package",
        module: "sale-package",
        icon: "mdi mdi-package-up",
        class: "",
        extralink: false,
        submenu: [],
      },
      {
        path: "/user/advance_booking",
        title: "Advance Booking",
        icon: "fa fa-book",
        module: "advance_booking",
        class: "",
        extralink: false,
        submenu: [],
      },
      {
        path: "/user/request_payment",
        title: "Request Payment",
        icon: "fa fa-credit-card",
        module: "request_payment",
        class: "",
        extralink: false,
        submenu: [],
      },

      {
        path: "/user/package_addon",
        title: "Addon Package",
        icon: "mdi mdi-package-variant-closed",
        module: "package_addon",
        class: "",
        extralink: false,
        submenu: [],
      },
      {
        path: "/user/pay-later-payment",
        title: "Pay Later Payments",
        icon: "fa fa-cart-plus",
        module: "pay-later-payment",
        class: "",
        extralink: false,
        submenu: [],
      },
      {
        path: "/user/coupon_code",
        title: "Coupon Code For All Packages",
        icon: "mdi mdi-ticket-percent",
        module: "coupon_code",

        class: "",
        extralink: false,
        submenu: [],
      },
      {
        path: "/user/used-coupons",
        title: "Used Coupon codes",
        icon: "mdi mdi-ticket-percent",
        module: "used-coupons",

        class: "",
        extralink: false,
        submenu: [],
      },
      {
        path: "/user/warning-feature",
        title: "Warning Feature",
        icon: "mdi mdi-account-alert",
        module: "warning-feature",

        class: "",
        extralink: false,
        submenu: [],
      },
    ],
  },
  {
    // path: "/user/dashboard",
    title: "Assets",
    icon: "fas fa-location-arrow",
    class: "has-arrow",
    hasSubmenu: true,
    extralink: false,
    submenu: [
      {
        path: "/user/assets",
        title: "Assets",
        module: "assets",
        icon: "fas fa-location-arrow",
        class: "",
        extralink: false,
        submenu: [],
      },
      {
        path: "/user/my-assets",
        title: "My assets",
        module: "my-assets",
        icon: "fa fa-solid fa-thumbtack",
        class: "",
        extralink: false,
        submenu: [],
      },
      {
        path: "/user/track-assets",
        title: "Track Assets",
        module: "track-assets",
        icon: "fa fa-truck",
        class: "",
        extralink: false,
        submenu: [],
      },
      {
        path: "/user/parking-violation",
        title: "Parking Violation",
        module: "parking-violation",
        icon: "mdi mdi-label",
        class: "",
        extralink: false,
        submenu: [],
      },
      {
        path: "/user/geofence",
        title: "Geofence",
        module: "geofence",
        icon: "fa fa-map-marker",
        class: "",
        extralink: false,
        submenu: [],
      },
      {
        path: "/user/operation",
        title: "Put into Operation",
        module: "operation",
        icon: "mdi mdi-star-circle",
        class: "",
        extralink: false,
        submenu: [],
      },
    ],
  },
  {
    // path: "/user/payment-method",
    title: "Payment",
    icon: "mdi mdi-wallet",
    class: "has-arrow",
    hasSubmenu: true,
    extralink: false,
    submenu: [
      {
        path: "/user/pending-amount",
        title: "Pending Amount",
        module: "pending-amount",
        icon: "mdi mdi-wallet",
        class: "",
        extralink: false,
        submenu: [],
      },
    ],
  },
  {
    // path: "/user/waiver-forms",
    title: "Waiver forms",
    icon: "mdi mdi-car",
    class: "has-arrow",
    hasSubmenu: true,
    extralink: false,
    submenu: [
      {
        path: "/user/waiver-forms",
        title: "Waiver forms (Customers)",
        module: "waiver-forms",
        icon: "mdi mdi-format-align-justify",
        class: "",
        extralink: false,
        submenu: [],
      },
      {
        path: "/user/waiver-terms/frekis",
        title: "Waiver forms (Frekis)",
        module: "frekis",
        icon: "mdi mdi-arrange-bring-forward",
        class: "",
        extralink: false,
        submenu: [],
      },
      {
        path: "/user/waiver-terms/sharekayak",
        title: "Waiver forms (Sharekayak)",
        module: "sharekayak",
        icon: "mdi mdi-arrange-bring-forward",
        class: "",
        extralink: false,
        submenu: [],
      },
      {
        path: "/user/waiver-terms/shrvee",
        title: "Waiver forms (Shrvee Services)",
        module: "shrvee",
        icon: "mdi mdi-arrange-bring-forward",
        class: "",
        extralink: false,
        submenu: [],
      },
      {
        path: "/user/license",
        title: "License",
        module: "license",
        icon: "mdi mdi-file-lock",
        class: "",
        extralink: false,
        submenu: [],
      },
    ],
  },
  {
    // path: "/user/my-asset-ride-history",
    title: "History",
    icon: "mdi mdi-history",
    class: "has-arrow",
    hasSubmenu: true,
    extralink: false,
    submenu: [
      {
        path: "/user/my-ride-history",
        title: "My Ride History",
        module: "my-ride-history",
        icon: "mdi mdi-arrange-bring-forward",
        class: "",
        extralink: false,
        submenu: [],
      },
      {
        path: "/user/my-asset-ride-history",
        title: "My Asset Ride History",
        module: "my-asset-ride-history",
        icon: "mdi mdi-arrange-bring-forward",
        class: "",
        extralink: false,
        submenu: [],
      },
      {
        path: "/user/my-book-history",
        title: "My Book History",
        module: "my-book-history",
        icon: "mdi mdi-arrange-bring-forward",
        class: "",
        extralink: false,
        submenu: [],
      },
      {
        path: "/user/lock-fallback",
        title: "Lock Fallback History",
        module: "lock-fallback",
        icon: "mdi mdi-lock",
        class: "",
        extralink: false,
        submenu: [],
      },
      {
        path: "/user/purchase-history",
        title: "Purchase History",
        icon: "mdi mdi-alert-circle",
        module: "purchase-history",
        class: "",
        extralink: false,
        submenu: [],
      },
    ],
  },
  {
    path: "/user/notifications",
    title: "Notifications",
    icon: "mdi mdi-bell-ring",
    module: "notifications",
    class: "",
    hasSubmenu: false,
    extralink: false,
    submenu: [],
  },

  {
    // path: "/user/privacy-policy",
    title: "Platform Support",
    icon: "fa fa-question-circle",
    class: "has-arrow",
    hasSubmenu: true,
    extralink: false,
    submenu: [
      {
        path: "/user/privacy-policy",
        title: "Privacy-policy",
        module: "privacy-policy",
        icon: "fa fa-user-secret",
        class: "",
        extralink: false,
        submenu: [],
      },
      {
        path: "/user/term-conditions",
        title: "Term & Conditions",
        module: "term-conditions",
        icon: "fa fa-user-secret",
        class: "",
        extralink: false,
        submenu: [],
      },
      {
        path: "/user/support/faq",
        title: "FAQ",
        module: "faq",
        icon: "fa fa-solid fa-question",
        class: "",
        extralink: false,
        submenu: [],
      },
      {
        path: "/user/support/operator-support",
        title: "Operator Support",
        module: "operator-support",
        icon: "fa fa-solid fa-question",
        class: "",
        extralink: false,
        submenu: [],
      },
      {
        path: "/user/support/feedback",
        title: "Feedback",
        module: "feedback",
        icon: "fa fa-solid fa-question",
        class: "",
        extralink: false,
        submenu: [],
      },
      {
        path: "/user/pludda",
        title: "Pludda",
        module: "pludda",
        icon: "mdi mdi-archive",
        class: "",
        extralink: false,
        submenu: [],
      },
      // {
      //   path: "/user/external-api",
      //   title: "External Apis",
      //   module: "external-api",
      //   icon: "mdi mdi-format-align-justify",
      //   class: "",
      //   extralink: false,
      //   submenu: [],
      // },
    ],
  },
];

function filterRoutesByPermission(routes: any) {
  const raw = localStorage.getItem("Auth-user");

  const parsed = JSON.parse(raw || "{}");
  let permissions = parsed?.permissions || [];

  const allowedTitles = permissions.map((p: any) => p.title.toLowerCase());

  const filteredRoutes = routes
    .map((route: any) => {
      const filteredSubmenu = (route.submenu || []).filter((sub: any) =>
        allowedTitles.includes(sub.title.toLowerCase())
      );

      const isParentAllowed = allowedTitles.includes(route.title.toLowerCase());

      if (isParentAllowed || filteredSubmenu.length > 0) {
        return {
          ...route,
          submenu: filteredSubmenu,
        };
      }

      return null;
    })
    .filter((r: any) => r !== null);

  return filteredRoutes;
}

// export const EMPLOYEE_ROUTES: any = filterRoutesByPermission(
//   ORIGINAL_EMPLOYEE_ROUTES
// );

export const EMPLOYEE_ROUTES: any = ORIGINAL_EMPLOYEE_ROUTES;
